import { render, staticRenderFns } from "./realEstatePanel.vue?vue&type=template&id=7422b97c&"
import script from "./realEstatePanel.vue?vue&type=script&lang=js&"
export * from "./realEstatePanel.vue?vue&type=script&lang=js&"
import style0 from "./realEstatePanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports